import React, { Fragment } from 'react';
import CardLogo from './Logo/Logo';
import Form from './Form';
import './CardForm.scss';

const CardForm = (props) => {
    return (
        <Fragment>
            <Form />
            <CardLogo />
        </Fragment>
    );
};

export default CardForm;